import { render } from "./ReportSaleChannelsIndex.vue?vue&type=template&id=ec4c1d00&scoped=true"
import script from "./ReportSaleChannelsIndex.vue?vue&type=script&lang=js"
export * from "./ReportSaleChannelsIndex.vue?vue&type=script&lang=js"

import "./ReportSaleChannelsIndex.vue?vue&type=style&index=0&id=ec4c1d00&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4c1d00"]])

export default __exports__